export const economicIndicatorsRoutePaths = {
  economicIndicators: {
    path: 'economic-indicators',
    url: '/economic-indicators',
  },
} as const;
